import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

import {AppConfig} from '../app.config';
import {Act, Region} from 'app/models/act';
import {ActListResponse, APIResponse} from 'app/models/response';



@Injectable()
export class ActService {
  endpoint = '';

  constructor(private http: HttpClient, private config: AppConfig) {
    this.endpoint = config.getConfig('api_endpoint');
  }

  getAll( page, pageSize, filters = {}, orderBy = 'createdAt'): Observable<any> {
    const params = {
      page: page,
      pageSize: pageSize,
      orderBy: orderBy,
      ...filters
    };
    return this.http.post<ActListResponse>(this.endpoint + '/act/list', params);
  }

  getReferences( parameters = {} ) {
    return this.http.post<APIResponse>(this.endpoint, { method: 'acts.references', params: parameters }).map(response => {
      const references: Array<any> = [];
      if (response && response.api_status == 0) {
        response.data.map( ref => references.push(ref) );
      }
      return references;
    });
  }

  getById(id: number): Observable<Act> {
    return this.http.post<APIResponse>(this.endpoint, { method: 'acts.get', params: { ID: id } })
      .map( response => {
        if (response && response.api_status == 0) {
          return Act.create(response.data);
        }
      });
  }

  create(model: Act) {
    return this.http
      .post<APIResponse>(this.endpoint, {method: 'acts.create', params: model })
      .map( response => {
        if (response && response.api_status == 0) {
          return response.data;
        } else {
          throw new Error( response.api_message );
        }
      });
  }

  update(model: Act) {
    return this.http
      .post<APIResponse>(this.endpoint, {method: 'acts.update', params: model })
      .map( response => {
        if (response && response.api_status == 0) {
          return response.data;
        } else {
          if ( typeof response === 'string') {
            throw new Error( response );
          } else {
            throw new Error( response.api_message );
          }

        }
      });
  }

  updateStatus(id, new_status, reason = '') {
    return this.http
      .post<APIResponse>(this.endpoint, {method: 'acts.updateStatus', params: {id: id, status: new_status, reason: reason} })
      .map( response => {
        if (response && response.api_status == 0) {
          return response;
        } else {
          if ( typeof response === 'string') {
            throw new Error( response );
          } else {
            throw new Error( response.api_message );
          }

        }
      });
  }

  updateBranch(id, branch) {
    return this.http
      .post<APIResponse>(this.endpoint, {method: 'acts.updateBranch', params: {id: id, branch: branch} })
      .map( response => {
        if (response && response.api_status == 0) {
          return response;
        } else {
          if ( typeof response === 'string') {
            throw new Error( response );
          } else {
            throw new Error( response.api_message );
          }

        }
      });
  }

  delete(id: number) {
    return this.http.post<APIResponse>(this.endpoint, {method: 'users.delete', params: { id: id } }).map( response => {
      if (response && response.api_status != 0) {

      } else {
        if ( typeof response === 'string') {
          throw new Error( response );
        } else
        if (response && response.api_status != 0) {
          throw new Error( response.api_message );
        }
      }
    });
  }

  regions(): Observable<Region[]> {
    return this.http.get<Region[]>(this.endpoint + '/act/regions');
  }

}



// WEBPACK FOOTER //
// D:/Projects/mvdclick/frontend/src/app/services/act.service.ts